import { render, staticRenderFns } from "./StandardActionList.vue?vue&type=template&id=144c62d2&scoped=true"
import script from "./StandardActionList.vue?vue&type=script&lang=js"
export * from "./StandardActionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144c62d2",
  null
  
)

export default component.exports